
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsBrandTypeGrid extends Serenity.EntityGrid<CsBrandTypeRow, any> {
        protected getColumnsKey() { return CsBrandTypeColumns.columnsKey; }
        protected getDialogType() { return CsBrandTypeDialog; }
        protected getIdProperty() { return CsBrandTypeRow.idProperty; }
        protected getInsertPermission() { return CsBrandTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return CsBrandTypeRow.localTextPrefix; }
        protected getService() { return CsBrandTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}